$(document).ready(function () {
    const $searchInput = $("#searchInputBook");
    const $suggestionsList = $("#suggestions");
    $('#check_container_sales_data').prop('checked', false);
    $("#view_container_sales_data").hide()

    $(".div_efectivo").hide();


    if ($searchInput.length) {

        $searchInput.on("input", function () {

            let title = $(this).val();
            let title_length = title.length;

            if (!title) {
                $suggestionsList.html("");
                return;
            }

            if (title_length >= 2) {
                $searchInput.css("border-color", "#52f500")
                let data = new FormData()
                data.append('title', title)
                sendData("search-book", data);
            }


        });
    }

    showModal = ($cover, $price, $title, $authors_text, $slug, $discount, $price_with_discount) => {
        $(".modal-title").html($title)
        $("#modal_show_book").modal('show');
        $(".img-book-pdv").attr("src", $cover);


        $(".pdv_title").html($title)
        $(".pdv_author").text($authors_text)
        $(".pdv_slug_title").val($slug)
        if ($discount > 0) {
            $(".div_discounts").show()
            $(".pdv_discount").text("Descuento:"+$discount+ "%")
            $(".price_with_discount").text("Precio: € "+$price_with_discount)
            $(".pdv_price").text("Precio: €" + $price).css("text-decoration", "line-through");
        }
        else{
            $(".div_discounts").hide()
            $(".pdv_price").text("Precio: €" + $price).css("text-decoration", "none");
        }
    }

    window.btnCancel = function () {
        $(".img-book-pdv").attr("src", "https://www.editorialalmadia.com/images/covers/portada_libro.png");
    }

    $('#check_container_sales_data').change(function () {
        if ($(this).is(':checked')) {
            $("#view_container_sales_data").show()
        } else {
            $("#view_container_sales_data").hide()
        }
    });

    updateSuggestions = (suggestions) => {

        const $suggestionsList = $("#suggestions");
        const $searchInput = $("#searchInput");

        $suggestionsList.empty();

        if (suggestions.length === 0) {
            $suggestionsList.append("<li>No se encontraron resultados</li>");
            return;
        }

        suggestions.forEach((item) => {
            let $cover = "https://editorialalmadia.com/images/covers/" + item.image;
            let $price = item.price;
            let $title = item.title;
            let $authors_text = item.authors_text;
            let $slug = item.slug;
            let $discount = item.discount;
            let $price_with_discount = item.price_with_discount;

            const $li = $("<li></li>")
                .text($title)
                .css({
                    cursor: "pointer", padding: "5px"
                })
                .on("click", function () {
                    $("#searchInputBook").val('')
                    showModal($cover, $price, $title, $authors_text, $slug, $discount, $price_with_discount)
                    $suggestionsList.empty();
                });
            $suggestionsList.append($li);
        });
    }


    function sendData(route, data) {
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {

                setTimeout(function () {
                    updateSuggestions(response);


                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                /*var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });*/
            }
        })
    }

});
